import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-cap-page-header',
  template: `
    <div class="title-block">
      <div class="title-logo">
          <img src="{{page.src}}" alt="page title"/>
      </div>
      <div class="page-title-details">
          <h3>{{page.title}}</h3>
          <p>{{page.description}}</p>
      </div>
    </div>
  `,
  styles: [`
            *{
              margin: 0px;
              padding: 0px;
            }
            .title-block {
              float:left;
              display: flex;
              align-items: center;
              max-width: 450px;
            }
            .title-block .title-logo{
              width: 45px;
              height: 45px;
              margin-right: 10px;
            }
            .title-block .title-logo img {
              width:100%;
              height:100%;
            }
            .title-block .page-title-details h3  {
              color: #55585A;
              font-size: 20px;
              line-height: 30px;
              font-weight:400;
            }
            .title-block .page-title-details p{
              font-size: 14px;
              color: #ccc;
            }
  `]
})
export class CapPageHeaderComponent implements OnInit {

  @Input() page;
  
  constructor() { }

  ngOnInit() {
  }

}
